export default __webpack_public_path__ + "static/Group 437-6e7d6260161d607fa0b5a31684d82c31.png";